<template>
  <v-container
    fluid
    class="d-flex align-center justify-center"
    style="height:100%"
  >
    <v-row class="justify-center flex-wrap" no-gutters>
      <v-col class="pb-0" cols="12" md="8">
        <v-text-field
          dense
          label="Great search engine coming soon!"
          append-icon="mdi-magnify"
          outlined
          rounded
          disabled
        ></v-text-field>
      </v-col>
      <v-col class="pb-5" cols="12" md="8">
        <video playsinline controls class="video">
          <source src="../assets/home_page_video01.mp4#t=4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>

<style lang="scss">
.video {
  width: 100%;
  min-width: 100%;
  // object-fit: cover;
  cursor: pointer;
  max-height: 300px;
}
</style>
